import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { esEmpresaDemo } from '../empresa-demo';
import { INICIO_DE_LA_DEMO } from './volver-con-el-plan-completo';

/**
 * Ronda Z (F6): `/dashboard` es a donde cae el ingreso y «Volver al inicio». Inicio es del
 * plan completo, así que en una demo, entrar por ahí abría solo el cuadro «Plan completo»
 * encima del recorrido. Quien entra por la puerta de siempre va directo al inicio de la
 * prueba, sin cuadro: ese cuadro es para quien toca algo con candado, no para quien llega.
 */
export function EntradaDeInicio({ children }: { children: ReactNode }) {
  if (esEmpresaDemo()) return <Navigate to={INICIO_DE_LA_DEMO} replace />;
  return <>{children}</>;
}
